<style >
    .ivu-table{
        font-size: 12px !important;
    }
</style>
<template>
    <div >
        <div class="text-right margin-bottom-10">
            <span style="width:40px;display:inline-block">sku</span>
            <div class="ivu-date-picker margin-left-10" style="width:150px;">
                <Input type="textarea" :rows="1" v-model="skus"></Input>
            </div>
            <Button class="margin-left-10" type="primary" @click="searchsku">查询</Button>
            <Button class="margin-left-10" @click="resetsku">重置</Button>
        </div>
        <Table :columns="columns" :data="tableList" @on-selection-change="setCheckData"></Table>
        <div class="text-right margin-top-10">
            <Button type="primary" @click="submit">确定</Button>
            <Button class="margin-left-10" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpReleaseReserve,HttpFindItemBySku } from '@/service/setting';
export default {
    props:['id','itemList'],
    data(){
        return {
            errFlag:false,
            skus:'',
            tableList:[],
            chooseList:[],
        }
    },
    created(){
        this.searchsku();
    },
    computed:{
        columns(){
            return [
                {
                    type: "selection",
                    formName: "id",
                    width: 60
                }, 
                {
                    title:'No.',
                    type:'index',
                    width: 60
                },
                {
                    title:'SKU',
                    key:'sku'
                },
                {
                    title:'预留数量/已释放',
                    render: (h, { row,index }) => {
                        return <div>
                            <div>{row.qty || '--'}/{row.qtyDone || '--'}</div>
                        </div>
                    }
                },
                {
                    title:'释放数量',
                    render: (h, { row,index }) => {
                        return h('Input', {
							props: {
								value: Number(row.qty) - Number(row.qtyDone || 0) || 0,
                                min:0
							},
							on: {
								'input': (event) => {
                                    if(/[0-9]/g.test( event )){
                                        if(/^[+]{0,1}(\d+)$/g.test( event )){
                                            row.releaseQty = event || 0
                                            row.flag = true;
                                            this.tableList[index] = row;
                                        }else{
                                            this.errFlag = true;
                                            this.$Message.error('请输入正整数！');
                                        }
                                    }else{
                                        row.releaseQty = 0;
                                        this.tableList[index] = row
                                        this.errFlag = true;
                                        this.$Message.error('请输入数字');
                                        // this.flag = true
                                    }
								},
							},
						})
                    }
                    
                },
            ]
        }
    },
    methods:{
        searchsku(){
            // 根据换行来截取
            let ordernos=this.skus.replace(/\n/g,",")
            HttpFindItemBySku({
                reserveOrderId:this.id,
                skus:ordernos,
            }).then(res=>{
                this.tableList = res.data
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        resetsku(){
            this.skus = '';
            this.searchsku()
        },
        setCheckData(list){
            this.chooseList = list
        },
        submit(){
            if(this.chooseList.length==0){
                this.$Message.error('请选择需要释放的SKU！')
                return
            }
            if(this.errFlag) {
                this.$Message.error('请输入正确内容！')
                this.errFlag = false;
                return
            };
            // 根据选择的list去取tablelist的值
            let arr=[];
            this.tableList.map(item=>{
                this.chooseList.map(json=>{
                    if(item.id==json.id){
                        arr.push(item)
                    }
                })
            })
            arr.map(item=>{
                if(item.releaseQty == 0 || item.releaseQty == ''){
                    item.releaseQty = 0
                }else if(!item.flag){
                    item.releaseQty = Number(item.qty) - Number(item.qtyDone || 0)
                }
                
            })
            HttpReleaseReserve({
                orderId:this.id,
                releaseModelList:arr
            }).then(res=>{
                this.$Message.success(res.message);
                this.$emit('on-update');
                this.cancel()
            },err=>{
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>